import { List, ListItem, Stack } from "@mui/material";
import React, { useContext, useEffect, useReducer, useRef } from "react";
import { useParams } from "react-router-dom";

import DataContext from "../../../../../../../../../../context/DataContext";
import LoadingIndicator from "../../../../../../../../../global/LoadingIndicator";
import OrderingArrow from "../../../../../../../../../global/OrderingArrow";
import PaginationControls from "../../../../../../../../../global/PaginationControls";
import NoAvailableFollowUps from "../../../../CaseFollowUps/components/ui/NoAvailableFollowUps";
import STRINGS from "../../../../CaseFollowUps/components/utils/strings";

import FollowUpListItem from "./components/FollowUpListItem";
import {
  FollowUpListDispatchContext,
  FollowUpListStateContext,
} from "./context/HistoryListContext";
import useGetAllActionTypes from "./hooks/useGetAllActionTypes";
import {
  setCaseInfo,
  setCurrentPage,
  setCurrentPageURL,
  setOrderingVal,
  setShouldFetchData,
} from "./state/actions";
import { historyListReducer, initialState } from "./state/historyListReducer";

export default function HistoryListView({ caseInfo }) {
  const params = useParams();
  const [state, dispatch] = useReducer(historyListReducer, initialState);
  const { accessToken } = useContext(DataContext);
  const [fetchAllFollowUpData] = useGetAllActionTypes(
    params.id,
    state.orderingVal,
    state.paginationUrl,
    accessToken,
    dispatch
  );
  const scrollRef = useRef(null);

  const scrollToTop = () => {
    scrollRef.current.scroll({
      top: 0,
    });
  };
  useEffect(() => {
    let active = true;
    if (active) {
      if (!state.fetchIsLoading && state.shouldFetchData) {
        fetchAllFollowUpData(
          params.id,
          state.orderingVal,
          state.paginationUrl,
          accessToken,
          dispatch
        );
      }
    }
    return () => {
      active = false;
    };
  }, [
    state.shouldFetchData,
    params.id,
    state.orderingVal,
    state.paginationUrl,
    state.fetchIsLoading,
    accessToken,
    dispatch,
    fetchAllFollowUpData,
  ]);

  useEffect(() => {
    let active = true;
    if (active) {
      if (params.id) {
        setShouldFetchData(dispatch, true);
      }
    }
    return () => {
      active = false;
    };
  }, [dispatch, params]);

  useEffect(() => {
    let active = true;
    if (active) {
      if (caseInfo) {
        setCaseInfo(dispatch, caseInfo);
      }
    }
    return () => {
      active = false;
    };
  }, [dispatch, caseInfo]);

  const handleChange = (event, value) => {
    setCurrentPage(dispatch, value);
    if (value === 1) {
      setCurrentPageURL(dispatch, `limit=${state.resLimit}`);
    }
    setCurrentPageURL(dispatch, `limit=${state.resLimit}&offset=${state.resLimit * (value - 1)}`);
    setShouldFetchData(dispatch, true);
    scrollToTop();
  };

  const resetPagination = () => {
    setCurrentPage(dispatch, 1);
    setCurrentPageURL(dispatch, "");
    setShouldFetchData(dispatch, true);
  };

  const sortList = (value) => {
    setShouldFetchData(dispatch, true);
    setOrderingVal(dispatch, value);
    resetPagination();
  };

  return (
    <FollowUpListDispatchContext.Provider value={dispatch}>
      <FollowUpListStateContext.Provider value={state}>
        <h1 className="mb-3 text-center text-[1.6rem] text-slate-800">
          {STRINGS.FOLLOW_UP_LIST_TITLE}
        </h1>

        <div className="bg-slate-200">
          <div className="flex w-full justify-between border-2 border-slate-300 bg-white px-0 py-3">
            <div className="w-[9%] text-center"></div>
            <div className="w-[20%] text-center">
              Due Date{" "}
              <OrderingArrow
                val={"due_date"}
                orderingVal={state.orderingVal}
                setOrderingVal={sortList}
              />
            </div>
            <div className="w-[20%] text-center">
              Type{" "}
              <OrderingArrow
                val={"action_type"}
                orderingVal={state.orderingVal}
                setOrderingVal={sortList}
              />
            </div>
            <div className="w-[20%] text-center">
              Completed At{" "}
              <OrderingArrow
                val={"completed_at"}
                orderingVal={state.orderingVal}
                setOrderingVal={sortList}
              />
            </div>
            <div className="w-[30%] text-center">
              Completed By{" "}
              <OrderingArrow
                val={"completed_by"}
                orderingVal={state.orderingVal}
                setOrderingVal={sortList}
              />
            </div>
          </div>
          <List className="h-[25vh] items-start overflow-y-auto p-0" ref={scrollRef}>
            {!state.fetchIsLoading ? (
              state.data.length > 0 ? (
                state.data.map((item, idx) => (
                  <ListItem className="m-0 p-0" key={"follow-up-item_list_" + item.id}>
                    <FollowUpListItem
                      key={"follow-up-item_list_" + item.id + idx}
                      id={item.id}
                      clock={item.clock_state}
                      label={item.label}
                      name={item.fieldName}
                      timeTillDueDate={item.relative_due_date}
                      dueDate={item.due_date}
                      detail={item.action_detail}
                      status={item.status}
                      actionType={item.actionType}
                      completedAt={item.completedAt}
                      completedBy={item.completedBy}
                      updatedAt={item.updatedAt}
                      updatedBy={item.updatedBy}
                      provider={item.provider}
                      client={item.client}
                    />
                  </ListItem>
                ))
              ) : (
                <NoAvailableFollowUps />
              )
            ) : (
              <LoadingIndicator isLoading={true} />
            )}
          </List>
        </div>
        {!state.fetchIsLoading && (
          <div className="py-2">
            <Stack alignItems={"center"}>
              <PaginationControls
                alignment={"center"}
                resultCount={state.resultCount}
                handleChange={handleChange}
                currentPage={state.currentPage}
              />
            </Stack>
          </div>
        )}
      </FollowUpListStateContext.Provider>
    </FollowUpListDispatchContext.Provider>
  );
}
